document.addEventListener('click', function(e) {
  const copyBtn = e.target.closest('.js-promo-copy-btn');
  if (!copyBtn) return;

  const promoCode = copyBtn.getAttribute('data-code');
  const banner = copyBtn.closest('.promo-banner');
  const tooltip = banner ? banner.querySelector('.js-promo-tooltip') : null;

  if (promoCode && navigator.clipboard) {
    navigator.clipboard.writeText(promoCode).then(function() {
      if (tooltip) {
        tooltip.classList.add('show');
        setTimeout(function() {
          tooltip.classList.remove('show');
        }, 1500);
      }
    }).catch(function(err) {
      console.error('Failed to copy promo code:', err);
    });
  }
});
